var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67676 2.12109V0.621094M7.67676 10.6211V9.12109M2.17676 3.62109H0.676758M10.6768 7.62109H9.17676M2.11613 5.64622L1.40902 6.35333C0.940411 6.82222 0.677215 7.45803 0.677313 8.12094C0.677412 8.78385 0.940796 9.41959 1.40955 9.88834C1.8783 10.3571 2.51403 10.6205 3.17694 10.6206C3.83985 10.6207 4.47567 10.3575 4.94456 9.88886L5.65166 9.18175M9.23745 5.59597L9.94456 4.88886C10.4132 4.41997 10.6764 3.78416 10.6763 3.12125C10.6762 2.45834 10.4128 1.8226 9.94403 1.35385C9.47528 0.885103 8.83955 0.621718 8.17663 0.62162C7.51372 0.621522 6.87791 0.884717 6.40902 1.35333L5.70191 2.06043",
    stroke: "#123051",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.b58c2df6fd3f66f0c140831df7543191.svg";
export { ForwardRef as ReactComponent };